import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Popover, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/free-solid-svg-icons'

function SortablePopoverHeader({
  filters,
  setFilters,
  column,
  title,
  includeOrdering = true,
  popoverId = '',
  activePopoverId = null,
  setActivePopoverId = null
}) {
  const showPopover = activePopoverId === popoverId
  const target = useRef(null)

  const handleTogglePopover = (show) => {
    if (setActivePopoverId) {
      setActivePopoverId(show ? popoverId : null)
    }
  }

  const updateOrdering = (direction) => {
    if (filters.orderBy === column && filters.orderDirection === direction) {
      setFilters({
        ...filters,
        orderBy: null,
        orderDirection: null,
        page: 1
      })
    } else {
      setFilters({
        ...filters,
        orderBy: column,
        orderDirection: direction,
        page: 1
      })
    }
  }

  const isActive = filters.orderBy === column

  const popover = (
    <Popover id={`popover-sort-${column}`}>
      <Popover.Body>
        <div>
          <div className="mb-2">
            <strong className="small">Sort</strong>
          </div>
          <div className="d-flex gap-2">
            <Button
              data-testid="sort-asc"
              variant={
                filters.orderBy === column &&
                filters.orderDirection === 'asc'
                  ? 'primary'
                  : 'light'
              }
              size="sm"
              onClick={() => updateOrdering('asc')}
            >
              Sort Asc
            </Button>
            <Button
              data-testid="sort-desc"
              variant={
                filters.orderBy === column &&
                filters.orderDirection === 'desc'
                  ? 'primary'
                  : 'light'
              }
              size="sm"
              onClick={() => updateOrdering('desc')}
            >
              Sort Desc
            </Button>
          </div>
        </div>
      </Popover.Body>
    </Popover>
  )

  if (!includeOrdering) {
    return (
      <th style={{ cursor: 'default' }}>
        <span>{title}</span>
      </th>
    )
  }

  return (
    <th style={{ cursor: 'default' }}>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '4px'
        }}
      >
        {title}
        <OverlayTrigger
          trigger="click"
          placement="bottom"
          overlay={popover}
          show={showPopover}
          onToggle={handleTogglePopover}
          rootClose
        >
          <Button
            ref={target}
            data-testid={`sort-toggle-${column}`}
            variant={isActive ? 'primary' : 'light'}
            size="sm"
            className="ms-1 border-0"
            style={{
              padding: '2px 6px',
              minWidth: 'auto'
            }}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <FontAwesomeIcon icon={faFilter} size="xs" />
          </Button>
        </OverlayTrigger>
      </span>
    </th>
  )
}

SortablePopoverHeader.propTypes = {
  filters: PropTypes.shape({
    orderBy: PropTypes.string,
    orderDirection: PropTypes.oneOf(['asc', 'desc']),
    page: PropTypes.number
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
  column: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  includeOrdering: PropTypes.bool,
  popoverId: PropTypes.string,
  activePopoverId: PropTypes.string,
  setActivePopoverId: PropTypes.func
}

export default SortablePopoverHeader